import { useMemo, useState } from 'react';
import { flashTimeline } from '@/mocks/home';

const FILTERS = ['全部', '突发', '进展', '回应', '反转', '深扒'];

export default function FlashTimeline() {
  const [active, setActive] = useState('全部');

  const items = useMemo(
    () => (active === '全部' ? flashTimeline : flashTimeline.filter((i) => i.tag === active)),
    [active],
  );

  return (
    <section id="flash" className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <div className="mb-6 flex flex-wrap items-center gap-3 border-b-2 border-foreground-950 pb-3">
              <h3 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">快讯流</h3>
              <span className="flex items-center gap-1.5 rounded-full bg-primary-50 px-3 py-1 text-xs font-medium text-primary-700">
                <span className="h-1.5 w-1.5 rounded-full bg-primary-500 animate-pulse-dot" />
                每 5 分钟滚动更新
              </span>
            </div>

            <div className="mb-6 flex flex-wrap gap-2">
              {FILTERS.map((f) => (
                <button
                  key={f}
                  type="button"
                  onClick={() => setActive(f)}
                  className={`cursor-pointer whitespace-nowrap rounded-full px-3.5 py-1.5 text-sm transition-colors ${
                    active === f
                      ? 'bg-foreground-950 text-background-50'
                      : 'bg-background-100 text-foreground-700 hover:bg-background-200'
                  }`}
                >
                  {f}
                </button>
              ))}
            </div>

            <ol className="relative border-l border-background-300 pl-6">
              {items.map((item) => (
                <li key={item.id} className="relative pb-7 last:pb-0">
                  <span className="absolute -left-[31px] top-1.5 flex h-4 w-4 items-center justify-center rounded-full border-2 border-background-50 bg-primary-500">
                    <span className="h-1.5 w-1.5 rounded-full bg-background-50" />
                  </span>
                  <div className="group cursor-pointer rounded-lg border border-background-200 bg-background-100 p-4 transition-colors hover:border-primary-300 md:p-5">
                    <div className="mb-2 flex flex-wrap items-center gap-2">
                      <span className="font-heading text-lg font-bold text-primary-600">{item.time}</span>
                      <span className="rounded-md bg-secondary-100 px-2 py-0.5 text-xs font-medium text-secondary-900">{item.tag}</span>
                    </div>
                    <h4 className="text-base font-bold leading-snug text-foreground-900 transition-colors group-hover:text-primary-600">
                      {item.title}
                    </h4>
                    <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                  </div>
                </li>
              ))}
            </ol>
          </div>

          <aside className="flex flex-col gap-5">
            <div className="rounded-lg border border-background-200 bg-background-100 p-5">
              <div className="mb-3 flex items-center gap-2">
                <i className="ri-notification-3-line text-lg text-primary-600" />
                <h4 className="font-heading text-lg font-bold text-foreground-950">订阅瓜料更新</h4>
              </div>
              <p className="text-sm leading-relaxed text-foreground-600">留下你的联系方式，今日重磅有新进展时第一时间提醒你。</p>
              <input
                type="text"
                placeholder="输入邮箱或手机号"
                className="mt-4 w-full rounded-md border border-background-300 bg-background-50 px-3 py-2.5 text-sm text-foreground-900 outline-none placeholder:text-foreground-500 focus:border-primary-400"
              />
              <button
                type="button"
                className="mt-3 w-full cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                订阅最新爆料
              </button>
              <p className="mt-2 text-xs text-foreground-500">演示页面，暂不接入真实提交。</p>
            </div>

            <div className="rounded-lg border border-background-200 bg-accent-50 p-5">
              <div className="mb-3 flex items-center gap-2">
                <i className="ri-megaphone-line text-lg text-accent-800" />
                <h4 className="font-heading text-lg font-bold text-foreground-950">我有料要爆</h4>
              </div>
              <p className="text-sm leading-relaxed text-foreground-700">匿名投稿通道已开启，线索经核实后会标注首发来源。</p>
              <a
                href="#today"
                className="mt-4 flex cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-4 py-2.5 text-sm font-medium text-foreground-950 transition-colors hover:bg-accent-600"
              >
                <i className="ri-send-plane-line" />
                立即爆料
              </a>
            </div>

            <div className="rounded-lg border border-background-200 bg-foreground-950 p-5 text-background-100">
              <h4 className="mb-3 font-heading text-lg font-bold text-background-50">今日快讯数据</h4>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <div className="font-heading text-2xl font-black text-accent-400">128</div>
                  <div className="text-xs text-background-400">新增爆料</div>
                </div>
                <div>
                  <div className="font-heading text-2xl font-black text-accent-400">36</div>
                  <div className="text-xs text-background-400">已核实实锤</div>
                </div>
                <div>
                  <div className="font-heading text-2xl font-black text-accent-400">9</div>
                  <div className="text-xs text-background-400">爆发中事件</div>
                </div>
                <div>
                  <div className="font-heading text-2xl font-black text-accent-400">4.1 亿</div>
                  <div className="text-xs text-background-400">全网讨论量</div>
                </div>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}